import useSWR from "swr"

const contentful = require("contentful")

const client = contentful.createClient({
  space: process.env.GATSBY_CTF_SPACE_ID,
  environment: process.env.GATSBY_CTF_ENV,
  accessToken: process.env.GATSBY_CTF_CD_ACCESS_TOKEN,
})

/**
 * @param {object} query - the query to pass to contentful
 * @param {number} skip - how many entries to page past
 * @param {object | null} aggregatedResponse - The aggregate response from all pagings
 */
export const getAllTemplates = (
  query = { content_type: "template" },
  skip = 0,
  aggregatedResponse = null
) => {
  const limit = 1000

  return client
    .getEntries({
      ...query,
      limit: limit,
      skip: skip,
    })
    .then(response => {
      if (!aggregatedResponse) {
        aggregatedResponse = response
      } else {
        aggregatedResponse.items = aggregatedResponse.items.concat(
          response.items
        )
      }
      if (skip + limit <= response.total) {
        return getAllTemplates(query, skip + limit, aggregatedResponse)
      }
      return aggregatedResponse.items
    })
    .catch(console.error)
}

const query =
  "sys.id,fields.ratings,fields.downloads,fields.likes,fields.slug,fields.karbonTemplateIDs"
const templateFetcher = contentfulID => {
  return client
    .getEntry(contentfulID, {
      content_type: "template",
      select: query,
    })
    .then(response => response)
    .catch(console.error)
}

const allTemplatesFetcher = () => {
  return getAllTemplates({
    content_type: "template",
    select: query,
  })
}

export const useLiveTemplateData = contentfulID => {
  return useSWR(contentfulID, templateFetcher)
}
export const useLiveTemplatesData = () => {
  return useSWR("allTemplates", allTemplatesFetcher)
}
